import React, {useEffect, useState, useReducer, useContext} from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';

// import styles from './Widget.module.scss';
import {
  Filters,
  FiltersTags,
  AccordionTable,
  FooterTable,
  Map,
  Treemap,
  ViewSwitcher,
} from '../components';
import Context from '../context';
import {reducerFilters} from '../reducers';
import api from '../api';
import {sortByNameAndLanguage, filter} from '../helpers';
import {VIEW_PHYSICAL} from '../constants';

export const Widget = ({gKey}) => {
  const [data, setData] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [viewmode, setViewMode] = useState(VIEW_PHYSICAL);
  const [filters, dispatchFilters] = useReducer(
    reducerFilters.reducer,
    reducerFilters.initial,
  );
  const [loading, setLoading] = useState(true);
  const widgetContext = useContext(Context);
  const tier = !isEmpty(widgetContext.tier) ? widgetContext.tier : process.env.REACT_APP_TIER_DEFAULT;

  useEffect(() => {
    // eslint-disable-next-line require-jsdoc
    async function fetchData() {
      const newData = await api.getData(tier);
      const sortedDataTable = sortByNameAndLanguage(newData);

      setData(sortedDataTable);
      setDataTable(sortedDataTable);
      setLoading(false);
    }

    fetchData();
  }, [tier]);

  useEffect(() => {
    const filteredDataTable = filter(data, filters);

    setDataTable(filteredDataTable);
  }, [data, filters]);

  return (
    <Context.Provider
      value={{
        tier,
        data,
        setData,
        dataTable,
        setDataTable,
        loading,
        viewmode,
        filters,
        dispatchFilters,
      }}
    >
      <div>
        <Filters />
        <Map gKey={gKey} />
        <Treemap />
        <ViewSwitcher viewmode={viewmode} onChange={setViewMode} />
        <FiltersTags />
        <AccordionTable />
        <FooterTable withModalButton />
      </div>
    </Context.Provider>
  );
};

Widget.propTypes = {
  gKey: PropTypes.string,
};

Widget.defaultProps = {
  gKey: '',
};
